
import React from 'react';

const PasswordForgetPage = () => (
  <div>
    <h1>Forgot Password</h1>
  </div>
);

export default PasswordForgetPage;